<mat-slide-toggle [checked]="value" [disabled]="disabled" (change)="onSwitchChange($event)">
  @if (label) {
    <span [class.disabled-label]="disabled">{{ label }}</span>
  } @else {
    <ng-content></ng-content>
  }
</mat-slide-toggle>
